import type { FormDefinition } from './types'

export default {
  sections: {
    Teilnehmer: {
      fields: [
        { id: 'Teilnehmer.Nachname', control: 'text-or-date' },
        { id: 'Teilnehmer.Vorname', control: 'text-or-date' },
        { id: 'Teilnehmer.Kundennummer', control: 'display' },
        { id: 'Teilnehmer.Geburtsdatum', control: 'date' },
        { id: 'Teilnehmer.Straße', control: 'text-or-date' },
        { id: 'Teilnehmer.Hausnummer', control: 'text-or-date' },
        { id: 'Teilnehmer.PLZ', control: 'text-or-date' },
        { id: 'Teilnehmer.Ort', control: 'text-or-date' },
        { id: 'Teilnehmer.Telefon', control: 'text-or-date' },
        { id: 'Teilnehmer.E-Mail', control: 'text-or-date' },
      ],
    },
  },
} satisfies FormDefinition
